import { TFunction } from "next-i18next";
import { withCdnUrl } from "@smile2impress/attraction-utils";

import { mergeContent } from "utils/mergeContent";
import { PageContentProps } from "content/content.types";
import {
    OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE,
    PRIVACY_POLICY_LINKS_BY_LOCALE,
    UrlsConfig,
} from "configs/urlsConfig";
import contacts from "configs/contacts";

import defaultContent from "./common";

const pageContent = (t: TFunction, { locale }: PageContentProps) => {
    const content = defaultContent(t, { locale });

    return mergeContent(content, {
        header: {
            menuTitle: t("navigationMenuRelaunch:navigationMenu"),
            logoLink: UrlsConfig.MAIN,
            items: [
                {
                    text: t("navigationMenuRelaunch:navigationTreatments"),
                    highlighted: true,
                    items: [
                        {
                            text: t(
                                "navigationMenuRelaunch:navigationAligners"
                            ),
                            link: UrlsConfig.ALIGNERS,
                            image: {
                                images: [
                                    {
                                        png: withCdnUrl(
                                            "/images/relaunch/common/navigation/aligners.png"
                                        ),
                                    },
                                ],
                                defaultSrc: withCdnUrl(
                                    "/images/relaunch/common/navigation/aligners.png"
                                ),
                            },
                        },
                        {
                            text: t("navigationMenuRelaunch:navigationTeens"),
                            link: UrlsConfig.TEENS,
                            image: {
                                images: [
                                    {
                                        png: withCdnUrl(
                                            "/images/relaunch/common/navigation/teens.png"
                                        ),
                                    },
                                ],
                                defaultSrc: withCdnUrl(
                                    "/images/relaunch/common/navigation/teens.png"
                                ),
                            },
                        },
                        {
                            text: t("global:kidsPageTitle"),
                            link: UrlsConfig.KIDS,
                            image: {
                                images: [
                                    {
                                        png: withCdnUrl(
                                            "/images/relaunch/common/navigation/kids.png"
                                        ),
                                    },
                                ],
                                defaultSrc: withCdnUrl(
                                    "/images/relaunch/common/navigation/kids.png"
                                ),
                            },
                        },
                        {
                            text: t(
                                "navigationMenuRelaunch:navigationRetainers"
                            ),
                            link: UrlsConfig.RETAINERS_SUBSCRIPTION,
                            image: {
                                images: [
                                    {
                                        png: withCdnUrl(
                                            "/images/relaunch/common/navigation/retainers.png"
                                        ),
                                    },
                                ],
                                defaultSrc: withCdnUrl(
                                    "/images/relaunch/common/navigation/retainers.png"
                                ),
                            },
                        },
                    ],
                },
                {
                    text: t("navigationMenuRelaunch:navigationWhitening"),
                    link: UrlsConfig.WHITENING,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/whitening.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/whitening.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationWhy"),
                    link: UrlsConfig.WHY_IMPRESS,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/whyImpress.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/whyImpress.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationPricing"),
                    link: UrlsConfig.PRICES,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/prices.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/prices.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationClinics"),
                    link: UrlsConfig.LOCATIONS,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/locations.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/locations.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationResults"),
                    link: UrlsConfig.RESULTS,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/results.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/results.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationBlog"),
                    link: UrlsConfig.BLOG,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/blog.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/blog.png"
                        ),
                    },
                },
            ],
        },
        footer: {
            company: {
                links: [
                    {
                        id: "whyImpress",
                        name: t("global:whyImpressPageTitle"),
                        link: UrlsConfig.WHY_IMPRESS,
                    },
                    {
                        id: "press",
                        name: t("global:pressPageTitle"),
                        link: `mailto:${contacts.emailPress.link}`,
                    },
                    {
                        id: "careers",
                        name: t("global:careersPageTitle"),
                        link: "https://www.linkedin.com/company/impress-orthodontics/jobs/",
                        target: "_blank",
                    },
                    {
                        id: "blog",
                        name: t("global:blogPageTitle"),
                        link: UrlsConfig.BLOG,
                        target: "_self",
                    },
                    {
                        id: "offersAndDiscounts",
                        name: t("navigationMenuRelaunch:offersAndDiscounts"),
                        link: OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE[locale],
                    },
                ],
            },
            legal: {
                title: t("global:legalNoticeFooterTitle"),
                links: [
                    {
                        id: "privacyPolicy",
                        name: t("global:privacyPolicy"),
                        link: PRIVACY_POLICY_LINKS_BY_LOCALE[locale],
                    },
                    {
                        id: "cookiesPolicy",
                        name: t("global:cookiesPolicy"),
                        link: withCdnUrl(
                            `${UrlsConfig.POLICY}/cookies-policy_us.pdf`
                        ),
                    },
                    {
                        id: "cookiesSettings",
                        name: t("global:cookiesSettings"),
                        cookiesSetting: true,
                    },
                    {
                        id: "terms",
                        name: t("global:termsAndConditions"),
                        link: withCdnUrl(
                            `${UrlsConfig.POLICY}/terms-and-conditions_us.pdf`
                        ),
                    },
                    {
                        id: "recordConsent",
                        name: t("global:recordTakingConsent"),
                        link: withCdnUrl(
                            `${UrlsConfig.POLICY}/record-taking-consent_us.pdf`
                        ),
                    },
                ],
            },
            product: {
                title: t("global:productFooterText"),
                links: [
                    {
                        id: "aligners",
                        name: t("navigationMenuRelaunch:navigationAligners"),
                        link: UrlsConfig.ALIGNERS,
                    },
                    {
                        id: "teens",
                        name: t("navigationMenuRelaunch:navigationTeens"),
                        link: UrlsConfig.TEENS,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBUnderbite"),
                        link: UrlsConfig.UNDERBITE,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBDiastema"),
                        link: UrlsConfig.DIASTEMA,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBBuckTeeth"),
                        link: UrlsConfig.BUCKTEETH,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBCrookedTeeth"),
                        link: UrlsConfig.CROOKED_TEETH,
                    },
                ],
            },
        },
        contacts: {
            wa: {
                text: t("navigationMenuRelaunch:navigationWhatsApp"),
                link: contacts.whatsapp[locale].link,
                message: t("global:whatsappMessage"),
            },
        },
    });
};

export default pageContent;
